import React from 'react';
import { useForm } from 'react-hook-form';
import { TextField, Button, Stack, Typography } from '@mui/material';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';

const schema = z.object({
  newPassword: z.string().min(8, "Password must be at least 8 characters"),
  confirmPassword: z.string()
}).refine((data) => data.newPassword === data.confirmPassword, {
  message: "Passwords do not match",
  path: ["confirmPassword"],
});

export const PasswordChange = () => {
  const { register, reset, handleSubmit, formState: { errors } } = useForm({
    resolver: zodResolver(schema),
  });

  const onSubmit = async (data) => {
  const token = localStorage.getItem('token'); 

  try {
    const response = await fetch('/api/user/change-password', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ newPassword: data.newPassword })
    });

    const result = await response.json();
    if (result.success) {
      alert("Password changed successfully!");
      reset();
    } else {
      alert(result.message || "Update failed.");
    }
  } catch (error) {
    console.error("Error updating password:", error);
  }
};

  return (
    <Stack spacing={3} sx={{ width:"100%", mt: 4 }}
    display="flex" 
      justifyContent="center" 
      alignItems="center" >
      <Typography variant="h5">Change Password</Typography>
      
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={2}>
          <TextField
            {...register("newPassword")}
            label="New Password"
            type="password"
            error={!!errors.newPassword}
            helperText={errors.newPassword?.message}
            fullWidth
          />
          
          <TextField
            {...register("confirmPassword")}
            label="Confirm New Password"
            type="password"
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword?.message}
            fullWidth
          />

          <Button type="submit" variant="contained" color="primary">
            Update Password
          </Button>
        </Stack>
      </form>
    </Stack>
  );
};
export default PasswordChange;